/*
Add subtitles
*/

import paper from 'paper'

function getText() {
  let tt = "ShuStevens-Johnson syndromeShin splintsBasilisHepatitis DAyahuascaNightshadeCholera5-MeO-DIPTAloesEithinoha MolpadiaMonogenesCocainePramiracetamTMA-2StrifeH.B. Woodrose4-MethylaminorexAlprazolamPiperazinesAlzheimer's diseaseKriophorosNakawStomach fluHuang T'ingErectile dysfunctionCommon coldDiplopterysAmala SclerodermaChlordiazepoxidePituriGangreneKavaBelit-SeriDOMHenbaneLeishmaniasisHorusRheumatismSalmonellosisMOO-LAUHarmalaLymphogranuloma venereumHydrocodoneSamundraTetanusBres2C-BPuthiosHekatosTemazepamAmblyopiaMeperidineWhope 4-HO-MIPTSynovitisPalindromic rheumatismGynnisBotulismPsilocybin & PsilocinGrowth HormonePeritonitisEpikourios PCPUrienRepetitive strain injuryHuman papillomavirusNagi Tanka MulukuPeriwinkleSisiutl centaurTomitukaLicoriceVaricellaQuetiapineCherubismMultiple sclerosisAniracetamMeperidineAlcoholLeishmaniasisEshmunAneurduNightshadeTrigonosAchondroplasiaZuShuHashishUgly Way Chou WangMononucleosisAnpaoBaurosH.B. WoodroseThalestrisCocaineAsthmaAjokChloris ClonidineArgyriaSIDSSan PedroRusalkiEar infectionCannabisKetamineCannabinoidsThymomaSpice ProductTyphoid feverApraxiaAlingaNight blindnessCoronary heart diseaseAnadenantheraNutmegBrucellosisRubellaTennis elbowComfreyGHBPsilocybin & PsilocinObumoMictecacihuatl"

  function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  tt = shuffle(tt.split(' ')).join(' ').replace(/\s+/g, '')

  return tt.substr(0, Math.random() * 32)
}


function subtitle(content) {
  let g = new Group()

  let size = [320, 25]

  let path = new Shape.Rectangle({
      position: view.center,
      size,
      fillColor: 'black',
    })

  let pathInner = new Path.Rectangle({
      position: view.center,
      size: [size[0]-20, size[1]-5],
      fillColor: '#0000fa',
      insert: false
    })

  let text = new PointText(view.center)
  text.fontFamily = 'monospace'
  text.fillColor = '#f0f0f0'
  text.content = content
  text.fitBounds(pathInner)
  text.position = path.position

  if (text.bounds.width < path.size.width) {
    path.size = [text.bounds.width + 10, text.bounds.height]
  }

  g.addChild(path)
  g.addChild(text)

  return g
}

export default function() {
  let p = new Point(view.bounds.topLeft),
      sz = view.size

  let g = subtitle(getText())

  let g2 = subtitle(getText())
  g2.position.y += g.bounds.height + 5
  g.addChild(g2)
}
